import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { useInput, FieldTitle } from 'ra-core';

import { CommonInputProps } from './CommonInputProps';
import { sanitizeInputRestProps } from './sanitizeInputRestProps';
import { InputHelperText } from './InputHelperText';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

/**
 * Form input to edit a Date string value in the "YYYY-MM-DD" format (e.g. '2021-06-23').
 *
 * Renders a date picker (the exact UI depends on the browser).
 *
 * @example
 * import { Edit, SimpleForm, DateInput } from 'react-admin';
 *
 * const PostEdit = (props) => (
 *     <Edit {...props}>
 *         <SimpleForm>
 *             <DateInput source="published_at" />
 *         </SimpleForm>
 *     </Edit>
 * );
 *
 * @example
 * // If the initial value is a Date object, DateInput converts it to a string
 * // but you must pass a custom parse method to convert the form value
 * // (which is always a date string) back to a Date object.
 * <DateInput source="published_at" parse={val => new Date(val)} />
 */
export const DateInput = ({
    className,
    defaultValue,
    format = getStringFromDate,
    label,
    name,
    source,
    resource,
    helperText,
    margin,
    onBlur,
    onChange,
    parse,
    validate,
    variant,
    ...rest
}: DateInputProps) => {
    const { field, fieldState, formState, id, isRequired } = useInput({
        defaultValue,
        name,
        format,
        parse,
        onBlur,
        onChange,
        resource,
        source,
        validate,
        ...rest,
    });

    const { error, invalid, isTouched } = fieldState;
    const { isSubmitted } = formState;

    // const [value, setValue] = React.useState<Date | null>(
    //     new Date("2022/01/01"),
    //   );
    
    //   const handleChange = (newValue: Date | null) => {
    //     setValue(newValue);
    //   };

    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                    // label="Date desktop"
                    inputFormat="MM/dd/yyyy"
                    // inputFormat="MM/yyyy"
                    // value={value}
                    // onChange={handleChange}
                    // renderInput={(params) => <TextField {...params} />}
                    id={id}
                    {...field}
                    className={clsx('ra-input', `ra-input-${source}`, className)}
                    type="date"
                    size="small"
                    variant={variant}
                    margin={margin}
                    // error={(isTouched || isSubmitted) && invalid}
                    // error={false}

                    // helperText={
                    //     <InputHelperText
                    //         touched={isTouched || isSubmitted}
                    //         error={error?.message}
                    //         helperText={helperText}
                    //     />
                    // }
                    label={
                        <FieldTitle
                            label={label}
                            source={source}
                            resource={resource}
                            isRequired={isRequired}
                        />
                    }
                    InputLabelProps={defaultInputLabelProps}
                    {...sanitizeInputRestProps(rest)}
                    renderInput={(params) => <TextField {...params} error={(isTouched || isSubmitted) && invalid} helperText={error?.message} />}
                />
            </LocalizationProvider>
            {/* <TextField
                id={id}
                {...field}
                className={clsx('ra-input', `ra-input-${source}`, className)}
                type="date"
                size="small"
                variant={variant}
                margin={margin}
                error={(isTouched || isSubmitted) && invalid}
                helperText={
                    <InputHelperText
                        touched={isTouched || isSubmitted}
                        error={error?.message}
                        helperText={helperText}
                    />
                }
                label={
                    <FieldTitle
                        label={label}
                        source={source}
                        resource={resource}
                        isRequired={isRequired}
                    />
                }
                InputLabelProps={defaultInputLabelProps}
                {...sanitizeInputRestProps(rest)}
            /> */}

        </div>
        
    );
};

DateInput.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    resource: PropTypes.string,
    source: PropTypes.string,
};

export type DateInputProps = CommonInputProps &
    Omit<TextFieldProps, 'helperText' | 'label'>;

/**
 * Convert Date object to String
 *
 * @param {Date} value value to convert
 * @returns {String} A standardized date (yyyy-MM-dd), to be passed to an <input type="date" />
 */
const convertDateToString = (value: Date) => {
    if (!(value instanceof Date) || isNaN(value.getDate())) return '';
    const pad = '00';
    const yyyy = value.getFullYear().toString();
    const MM = (value.getMonth() + 1).toString();
    const dd = value.getDate().toString();
    // console.log(`${yyyy}-${(pad + MM).slice(-2)}-${(pad + dd).slice(-2)}`);
    return `${yyyy}-${(pad + MM).slice(-2)}-${(pad + dd).slice(-2)}`;
};

const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
const defaultInputLabelProps = { shrink: true };

export const getStringFromDate = (value: string | Date) => {
    // null, undefined and empty string values should not go through dateFormatter
    // otherwise, it returns undefined and will make the input an uncontrolled one.

    if (value == null || value === '') {
        return '';
    }

    if (value instanceof Date) {
        console.log("getStringFromDate 1");
        return convertDateToString(value);
    }

    // valid dates should not be converted
    if (dateRegex.test(value)) {
        return value;
    }

    return convertDateToString(new Date(value));
};


// export function MaterialUIPickers() {
//     const [value, setValue] = React.useState<Date | null>(
//       new Date(),
//     );
  
//     const handleChange = (newValue: Date | null) => {
//       setValue(newValue);
//     };
  
//     return (
//       <LocalizationProvider dateAdapter={AdapterDateFns}>
//         <DesktopDatePicker
//             label="Date desktop"
//             inputFormat="MM/dd/yyyy"
//             value={value}
//             onChange={handleChange}
//             renderInput={(params) => <TextField {...params} />}
//           />
//       </LocalizationProvider>
//     );
//   }